import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import TutorUpcomingClass from './TutorUpcomingClass'
import UpcomingClassesHeader from '../../../../pages/common/Statistic/UpcomingClassesHeader'
import UsePagination from '../../../pagination'

import { getTutorUpcomingClasses } from '../../../../routing/fetchingfunction/dashboard/dashboard.action'
import {
  selectLoadingTutorUpcomingClasses,
  selectTutorUpcomingClassesPagination,
} from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { getPaginationTotalLength } from '../../../../helpers'
import getUpcomingClassesFilters from '../../../../helpers/getUpcomingClassesFilters'

const TutorUpcomingClasses = () => {
  const dispatch = useDispatch()

  const {
    tutorUpcomingClasses,
    tutorUpcomingClassesPage,
    tutorUpcomingClassesPageSize,
    tutorUpcomingClassesTotal,
  } = useSelector(selectTutorUpcomingClassesPagination)
  const isLoading = useSelector(selectLoadingTutorUpcomingClasses)

  const [filters, setFilters] = useState({
    sort: 'closest',
    category: '',
    gender: '_',
    languages: '_',
    country_of_origin: '_',
    country_of_residence: '_',
    search: '',
  })

  const handlePageChange = (_, value) => {
    if (value !== tutorUpcomingClassesPage) {
      dispatch(
        getTutorUpcomingClasses({
          page: value,
          ...getUpcomingClassesFilters(filters),
        })
      )
    }
  }

  useEffect(() => {
    dispatch(
      getTutorUpcomingClasses({
        page: 1,
        ...getUpcomingClassesFilters(filters),
      })
    )
  }, [filters])

  const upcomingClassesContent = tutorUpcomingClasses.map((upcomingClass) => {
    return <TutorUpcomingClass key={upcomingClass.id} upcomingClass={upcomingClass} />
  })

  return (
    <div className="w-full mt-[50px]">
      <UpcomingClassesHeader filters={filters} setFilters={setFilters} />

      {upcomingClassesContent}

      {tutorUpcomingClassesTotal > tutorUpcomingClassesPageSize && (
        <div className="w-full flex items-center justify-center">
          <UsePagination
            count={getPaginationTotalLength(
              tutorUpcomingClassesTotal,
              tutorUpcomingClassesPageSize
            )}
            page={tutorUpcomingClassesPage}
            onChange={handlePageChange}
            loading={isLoading}
          />
        </div>
      )}
    </div>
  )
}

export default TutorUpcomingClasses
